import { 
    PRESUPUESTADOR_SET_LEAD_ID
  } from './constants'
  
  export function setLeadId(leadId) {
    return (dispatch) => {
      if(leadId) {
        dispatch({
          type: PRESUPUESTADOR_SET_LEAD_ID,
          data: leadId
        })
      }
    }
  }
  
  export function reducer(state, action) {
    if (action.type === PRESUPUESTADOR_SET_LEAD_ID) {
        return {
          ...state,
         lead_id: action.data,
        }
    }
    else {
        return state
    }
  }
  